@charset "UTF-8";

/* app/js/src/components/live/live-other-user-entered/live-other-user-entered.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  min-width: 550px;
  min-height: 200px;
}
:host:not(:has(.other-username-connected))::after {
  content: "\23f3";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  font-size: 5rem;
  text-align: center;
  text-transform: uppercase;
  animation: spinning-wheel-animation 1s linear infinite;
}
@keyframes spinning-wheel-animation {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.dialog-content {
  padding: 24px;
}
.dialog-message-box {
  background-color: #fffbeb;
  border-left: 4px solid #f59e0b;
  padding: 16px;
  margin-bottom: 16px;
}
.dialog-message-inner {
  display: flex;
  align-items: flex-start;
}
.dialog-message-icon-wrapper {
  flex-shrink: 0;
}
.dialog-message-icon {
  height: 20px;
  width: 20px;
  color: #d97706;
}
.dialog-message-text {
  margin-left: 12px;
}
.dialog-message-line {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #92400e;
  margin-bottom: 0;
}
.dialog-message-line + .dialog-message-line {
  margin-top: 8px;
}
.bold {
  font-weight: 600;
}
.dialog-timestamp {
  font-family:
    "Courier New",
    Courier,
    monospace;
  font-size: 0.875rem;
}
.dialog-info-text {
  color: #4b5563;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.dialog-info-text p {
  margin-bottom: 0;
}
.dialog-info-text p + p {
  margin-top: 8px;
}
/*# sourceMappingURL=live-other-user-entered.component.css.map */
